import Combobox from '@/libs/components/src/lib/form/Combobox';
import { ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import { BASE_ROLES, ROLES, User } from '@chiroup/core/types/User.type';
import { useState } from 'react';
import userService from '../../../services/user.service';
import Modal from '../../common/Modal';

type Props = {
  isOpen: OpenClosedStates;
  setIsOpen: (arg: OpenClosedStates) => void;
  user?: Partial<User>;
  clinicID?: number;
  isEHR?: boolean;
};

const ChangeRoleModal = ({ isOpen, setIsOpen, user, clinicID, isEHR }: Props) => {
  const [userRoleToUpdate, setUserRoleToUpdate] = useState<any>({
    role: user?.role,
  });

  const updateUserRole = () => {
    userService.updateUserClinic(userRoleToUpdate, user?.ID, clinicID);
  };

  const onChangeRole = (val: string) => {
    if (val) {
      const newRole = { role: val };
      setUserRoleToUpdate(newRole);
    }
  };

  const footerButtons = [
    {
      text: 'Close',
      onClick: () => setIsOpen(OpenClosedStates.Closed),
      color: ButtonColors.plainWithBorder,
    },
    {
      text: 'Confirm',
      onClick: updateUserRole,
      color: ButtonColors.primary,
    },
  ];

  return (
    <Modal
      isOpen={isOpen === OpenClosedStates.Open}
      close={() => setIsOpen(OpenClosedStates.Closed)}
      header={{ title: 'Change user role' }}
      footer={{ buttons: footerButtons }}
    >
      <form>
        <div>
          <div className="mt-3 text-center sm:mt-5">
            <div className="flex justify-center w-full">
              <Combobox
                options={isEHR ? ROLES : BASE_ROLES}
                name="role"
                value={userRoleToUpdate.role || user?.role}
                className="w-full"
                onChange={onChangeRole}
              />
            </div>
            <div className="mt-2">
              <p className="text-sm leading-5 text-gray-500 dark:text-dark-gray-400">
                Are you sure you wish to change this user's role?
              </p>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ChangeRoleModal;
